import { useCallback } from "react";
import { Button, Group, Input, NativeSelect, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import {
  BusinessCardFields,
  NewRequestFormProps
} from "../../types/request.types";
import CampusSelect from "../CampusSelect";
import FormAttachments from "../attachments/FormAttachments";
import FormContacts from "../contacts/FormContacts";

export default function BusinessCardForm(
  { onSubmit, tempId }: NewRequestFormProps
) {
  const form = useForm<BusinessCardFields>({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      title: '',
      campus_id: null,
      phone: '',
      mobile: '',
      fax: '',
      email: '',
      amount: 100
    }
  });

  const onFormSubmit = useCallback((submitVals: BusinessCardFields) => {
    onSubmit(submitVals);
  }, []);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <Input.Wrapper
        label="Contacts"
        mt="md"
      >
        <FormContacts<BusinessCardFields> form={form} />
      </Input.Wrapper>

      <TextInput
        {...form.getInputProps('name')}
        key={form.key('name')}
        label="Name"
        mt="md"
        required
      />

      <TextInput
        {...form.getInputProps('title')}
        key={form.key('title')}
        label="Title"
        required
      />

      <CampusSelect
        {...form.getInputProps('campus_id')}
        key={form.key('campus_id')}
        label="Campus"
        required
        mt="md"
      />

      <TextInput
        {...form.getInputProps('phone')}
        key={form.key('phone')}
        label="Office phone"
        required
        mt="md"
      />

      <TextInput
        {...form.getInputProps('mobile')}
        key={form.key('mobile')}
        label="Mobile phone"
        mt="md"
      />

      <TextInput
        {...form.getInputProps('fax')}
        key={form.key('fax')}
        label="Fax number"
        mt="md"
      />

      <TextInput
        {...form.getInputProps('email')}
        key={form.key('email')}
        label="Email"
        required
        mt="md"
      />

      <NativeSelect
        {...form.getInputProps('amount')}
        key={form.key('amount')}
        label="Amount"
        mt="md"
        required
        data={[100, 250].map(a => ({value: '' + a, label: `${a} cards`}))}
      />

      <Input.Wrapper
        label="Attachments"
        mt="md"
      >
        <FormAttachments tempId={tempId} />
      </Input.Wrapper>

      <Group justify="flex-end" mt="md" bg="gray.1" p="sm">
        <Button type="submit">Submit</Button>
      </Group>
    </form>
  );
}
